import React, { Component } from "react";
import { BoxInfo, MnemoLoading, ModalHandler } from "components/misc";
import { Container, Button } from "design-react-kit";
import { MTable } from "components/table";
import ReactHtmlParser from "react-html-parser";

import { AdminSurveyFormAnswer } from "./AdminSurveyFormAnswer";
import { adminService, networkErrorHelper } from "libs";

export class AdminSurveyFormListAnswer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idQuestion: this.props.idQuestion,
      loading: true,
      showList: true,

      surveyAnswers: [],
      formActive: false,
      answerValue: null,
      rndKey: 0,
    };
  }

  componentDidMount() {
    this.loadAnswers(this.props.idQuestion);
  }

  loadAnswers = (idQuestion) => {
    adminService
      .loadSurveyAnswers(idQuestion)
      .then(({ data }) => {
        const surveyAnswers = data.payload.surveyAnswers.map((a) => ({
          ...a,
          label: ReactHtmlParser(a.label),
        }));

        this.setState({
          surveyAnswers,
          loading: false,
          rndKey: Math.random(),
        });
      })
      .catch(() => this.setState({ loading: false }));
  };

  addNewAnswer = (idAnswer) => {
    if (idAnswer) {
      const answer = this.state.surveyAnswers.find((a) => a.id === idAnswer);
      this.setState({ answerValue: answer, formActive: true, showList: false });
    } else {
      this.setState({ answerValue: null, formActive: true, showList: false });
    }
  };

  showList = () => {
    this.setState({
      showList: true,
      formActive: false,
      rndKey: Math.random(),
    });
    this.loadAnswers(this.props.idQuestion);
  };

  //--- start functions to delete ---
  deleteRecord = (e, id) => {
    e.stopPropagation();
    ModalHandler.show(
      id,
      "Eliminazione risposta",
      "Vuoi davvero eliminare questa risposta?",
      null,
      this.deleteConfirmed
    );
  };

  deleteConfirmed = (id) => {
    adminService
      .deleteSurveyAnswer(id)
      .then(() => this.loadAnswers(this.state.idQuestion))
      .catch((error) => {
        console.error(error);
        if (networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };
  //---- end functions to delete ----

  renderList = () => {
    const { loading, surveyAnswers } = this.state;

    if (loading) return <MnemoLoading />;

    return (
      <Container
        key={this.state.rndKey}
        className="container-card-body-ListAnswer"
      >
        {surveyAnswers.length > 0 ? (
          <MTable
            key={this.state.rndKey}
            tableData={surveyAnswers}
            tableConfig={{
              columns: [{ id: "label", Header: "Risposte", accessor: "label" }],
              actions: [
                {
                  id: "detail",
                  accessor: "id",
                  label: "Dettagli",
                  icon: "it-file",
                  className: "MTable-actions",
                  onClick: (e, value) => {
                    this.addNewAnswer(value);
                  },
                },
                {
                  id: "delete",
                  accessor: "id",
                  label: "Elimina",
                  icon: "it-delete",
                  className: "MTable-actions",
                  onClick: (e, value) => this.deleteRecord(e, value),
                },
              ],
            }}
          />
        ) : (
          <BoxInfo>Questa domanda non ha ancora risposte inserite.</BoxInfo>
        )}

        <Button
          color="primary bg-dark"
          className="m-2"
          onClick={() => this.addNewAnswer(null)}
        >
          Nuova risposta
        </Button>
      </Container>
    );
  };

  renderForm = () => {
    return (
      <AdminSurveyFormAnswer
        idQuestion={this.props.idQuestion}
        answerValue={this.state.answerValue}
        formActive={this.state.formActive}
        showList={this.showList}
      />
    );
  };

  render() {
    return this.state.showList ? this.renderList() : this.renderForm();
  }
}
